import React, { useState } from 'react';

import ViewAllGuests from './view_all_guests';
import ReactModal from '~/../components/shared/components/react_modal';

const Guests = ({ guests, guestsRef, eventSlug, eventTitle }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSubtitle, setModalSubtitle] = useState(`${guests.guestCount} Guests`);

  const onModalClose = () => {
    setModalOpen(false);
    setModalSubtitle(`${guests.guestCount} Guests`);
  };

  const guestCountConditionals = () => {

    if (guests.guestCount > 0) {
      return `${guests.guestCount} Guests`;
    }
  };

  return (
    <>
      <div className='display-flex justify-between mb-32' ref={guestsRef}>
        {modalOpen &&
          <ReactModal title={eventTitle} subtitle={modalSubtitle} onClose={onModalClose} extraClasses=''>
            <ViewAllGuests eventSlug={eventSlug} setModalSubtitle={setModalSubtitle} />
          </ReactModal>
        }
        {!!guestCountConditionals() && (<label className='t1 w3'>{guestCountConditionals()}</label>)}

        {guests.guestCount > 6 && (
          <a className='fs-3' onClick={() => setModalOpen(true)}>
            View All
          </a>
        )}
      </div>
      <div
        className='card-grid'
        dangerouslySetInnerHTML={{ __html: guests.firstSixGuests }}
      />
    </>
  );
};

export default Guests;
